import React from 'react';
import styled from 'styled-components';

const ErrorContainer = styled.div`
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #f8d7da;
  color: #721c24;
  padding: 15px 20px;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-width: 90%;
  text-align: center;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: #721c24;
  font-size: 1.2rem;
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 10px;
`;

const ErrorMessage = ({ message, onClose }) => {
  return (
    <ErrorContainer>
      {message}
      {onClose && <CloseButton onClick={onClose}>×</CloseButton>}
    </ErrorContainer>
  );
};

export default ErrorMessage; 